
import Vue from "vue";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { IBreadCrumb, ISelectItem } from "winfakt-vue-components";
import { UserInfo } from "../../../models/dossier/user-info";
import { CompanyService } from "@/services/company-service";
import { AuthService } from "../../../services/auth-service";
import { Company } from "../../../models/company";
import AppUsersCopyViews from "@/components/settings-default/UsersCopyViews.vue";
import AppUsersShareViewsModal from "@/components/settings-default/UsersShareViewsModal.vue";

export default Vue.extend({
	data() {
		return {
			users: [] as UserInfo[],
			copyViewsModal: false,
			shareViewsModal: false
		};
	},
	computed: {
		currentDossierID(): number {
			return AuthService.wfDossier.id;
		},
		options(): ISelectItem<string>[] {
			return [
				{
					text: this.$ct("edit"),
					value: "edit",
					icon: "pen"
				},
				{
					text: this.$ct("remove"),
					value: "remove",
					icon: "trash"
				},
				{
					text: this.$ct("edit-views"),
					value: "edit-views",
					icon: "edit"
				}
			];
		},
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/",
					value: this.$ct("general")
				},
				{
					value: this.$ct("users")
				}
			] as IBreadCrumb[];
		},
		company(): Company {
			return AuthService.wfCompany;
		},
		maxUsersText(): string {
			if (!this.company) {
				return "";
			}
			return `${this.users.length}/${this.company.getMaxExtraUsersCount() + 1}`;
		},
		maxUsersReached(): boolean {
			if (!this.company) {
				return true;
			}
			return this.company.getMaxExtraUsersCount() + 1 <= this.users.length;
		},
		loggedInUserID(): number {
			if (!AuthService.wfUser) {
				return 0;
			}
			return AuthService.wfUser.ID;
		},
		title(): string {
			return `${this.$ct("users")} ${this.maxUsersText}`;
		},
		menuItems(): ISelectItem<Function>[] {
			return [
				{
					text: this.$ct("copy-views"),
					value: () => this.copyViewsModal = true
				},
				{
					text: this.$ct("share-views"),
					value: () => this.shareViewsModal = true
				},
			];
		},
		isOwner(): boolean {
			return AuthService.wfUser.ID == AuthService.wfCompany.OwnerID;
		}
	},
	methods: {
		addClicked() {
			if (this.maxUsersReached) {
				return;
			}
			this.$router.push("/settings/users/new");
		},
		async removeUser(user: UserInfo) {
			let text = this.$ct("confirm-delete-user", { username: user.Username });
			let confirm = await this.$wf.confirm(text, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "danger");
			if (!confirm) {
				return;
			}
			let i = this.users.indexOf(user);
			await CompanyService.deleteUser(user);
			this.users.splice(i, 1);
		},
		editUser(user: UserInfo) {
			this.$router.push(`/settings/users/${user.ID}`);
		},
		editUserViews(user: UserInfo) {
			this.$router.push(`/settings/users/views/${user.ID}`);
		},
		hasAccessToCurrentDossier(u: UserInfo): boolean {
			return u.hasAccessToDossier(AuthService.wfDossier.id);
		},
		canUserBeEdited(u: UserInfo): boolean {
			if (AuthService.wfUser.ID == AuthService.wfCompany.OwnerID) {
				return true;
			}
			if (AuthService.wfCompany.OwnerID == u.ID) {
				return false;
			}
			return AuthService.wfUser.ID != u.ID;
		},
		async loginAsUser(u:UserInfo) {
			let message = this.$ct("confirm-login-as-user-will-log-you-out", {user: u.getShortDisplayName()});
			let confirm = await this.$confirmBuilder(message).setWarningTitle().show();
			if (!confirm) return;
			await CompanyService.loginAsUser(u);
		}
	},
	async created() {
		this.users = await CompanyService.getUsers();
		this.users = this.users.filter(u => !u.QuietMode);
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppUsersCopyViews,
		AppUsersShareViewsModal
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
